import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {NavLink} from "react-router-dom";




const HeaderDesktopMenu: React.FC = () : JSX.Element => {
    return (
        <Box sx={{ display: 'flex', gap: 2 }}>
            <Button
                variant="text"
                color="secondary"
                component={NavLink}
                to="/"
            >
                Главная
            </Button>
            <Button
                variant="text"
                color="secondary"
                component={NavLink}
                to="/rules"
            >
                ПРАВИЛА
            </Button>
            <Button
                variant="text"
                color="secondary"
                component={NavLink}
                to="/product"
            >
                ПРОДУКТ
            </Button>
            <Button
                variant="text"
                color="secondary"
                component={NavLink}
                to="/service"
            >
                УСЛУГА
            </Button>
            <Button
                variant="text"
                color="secondary"
                component={NavLink}
                to="/timeline"
            >
                TIMELINE
            </Button>
            <Button
                variant="text"
                color="secondary"
                component={NavLink}
                to="/prizes"
            >
                ПРИЗЫ
            </Button>
            <Button
                variant="text"
                color="secondary"
                component={NavLink}
                to="/organizers"
            >
                ОРГАНИЗАТОР
            </Button>
            <Button
                variant="text"
                color="secondary"
                component={NavLink}
                to="/sponsors"
            >
                СПОНСОРЫ
            </Button>
        </Box>
    )
};

export default HeaderDesktopMenu;